import * as utils from '@utils/form';

export const FORM_FIELD = {
  VIDEOS: {
    name: 'video',
    label: 'Choose from existing videos:',
    rules: [{ required: true, message: 'Video is required' }],
    serialize: utils.relatedEntitySerializerForContentIdOrId,
    allowClear: false,
  },
};
export const FORM_FIELDS = Object.values(FORM_FIELD);

export const MODE = {
  EXISTING: {
    value: 'existing',
    label: 'Add an existing video',
  },
};
export const MODES = Object.values(MODE);

export const INITIAL_VALUES = {
  [FORM_FIELD.VIDEOS.name]: [],
};
